<script>
    export default {
        name: "BundleOverviewSection",
        data () {
            return {
                sectionType: "bundle-overview-section"
            }
        },
        computed : {
            dummyData () {
                return {
                    price: "150",
                    currency: "$",
                    discount_percentage: "10",
                    save: "15",
                    discount_price: "135"
                }
            },
            myBundleData () {
                let bundleFound = {};

                this.bundles.map(bundle => {
                    if (bundle.titleId === this.selectedBundleId) {
                        bundleFound = bundle;
                    }
                })

                return bundleFound;
            },
            selectedBundleId () {
                if (this.sectionData.selectedBundleId) {
                    return this.sectionData.selectedBundleId;
                }

                if (this.isPageContext('bundle') && this.pageContext.params && this.bundles.filter( bundle => bundle.titleId === this.pageContext.params.slug).length ) {
                    return this.pageContext.params.slug;
                }

                return "";
            },
            bundleSelectOptions () {
                let options =  this.bundles.map( bundle => {
                    return {label: bundle.title, value : bundle.titleId};
                });

                if (!this.isPageContext('bundle')) {
                    options.unshift({label: "None", value: ""});
                }
                return options;
            },
        },
        methods: {
            getDataForContext () {

                return new Promise( (resolve,reject) => {
                    if (!this.myBundleData.titleId) {
                        resolve(this.dummyData);
                    }

                    const bundleData = this.editBundleData(this.myBundleData);
                    resolve(bundleData);
                });
            },
            editBundleData (bundleData) {
                return bundleData;
            },
            getSelectedBundle () {
                return this.selectedBundleId;
            },
            setSelectedBundle (selectedBundleId) {
                this.changeMyData({selectedBundleId});
                this.setChangesAreSaved(false);
            }

        }
    }
</script>
